"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hfilterSagas = void 0;
var WindowApi_1 = require("@/api/browser/WindowApi");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var SignupAction_1 = require("@/pages/common/actions/SignupAction");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var HfilterAction_1 = require("@/pages/search/actions/HfilterAction");
var SearchMapAction_1 = require("@/pages/search/actions/SearchMapAction");
var SaveSearchDialogAction_1 = require("@/pages/search/actions/sfilter/SaveSearchDialogAction");
var SearchQueryAction_1 = require("@/pages/search/actions/sfilter/SearchQueryAction");
var getKeywordSuggestions_1 = require("@/pages/search/sagas/api/getKeywordSuggestions");
var SearchHistory_1 = require("@/pages/search/sagas/api/SearchHistory");
var RootSearchCallSaga_1 = require("@/pages/search/sagas/RootSearchCallSaga");
var Area_1 = require("@/pages/search/states/Area");
var effects_1 = require("redux-saga/effects");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var stateToSearchQuery_1 = require("@/transformers/stateToSearchQuery");
var ApplyFilterAction_1 = require("@/pages/search/actions/ApplyFilterAction");
var SbarAction_1 = require("@/pages/search/actions/sfilter/SbarAction");
var RootSearchMapCallSaga_1 = require("@/pages/search/sagas/RootSearchMapCallSaga");
var groupRows_1 = require("@/pages/common/transformers/groupRows");
var GetSuggestionApiResponse_1 = require("@/pages/search/states/GetSuggestionApiResponse");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var getPartBy_1 = require("@/pages/common/transformers/getPartBy");
var getAreaIsExpanded = function (state, area) { return state.hfilter.districts.find(function (it) { return Area_1.parentToArea(it.id) === area; }).expanded; };
var getCurrentHfilter = function (state) { return JSON.parse(JSON.stringify(state.hfilter)); };
var getIsFilterFullActive = function (state) { return state.hfilter.filterFullActive; };
var getIsPriceMinBiggerThanPriceMax = function (state) { return state.hfilter.priceMax !== 0 && state.hfilter.priceMax != -1 && state.hfilter.priceMin >= state.hfilter.priceMax; };
var getIsSizeMinBiggerThanSizeMax = function (state) { return state.hfilter.sizeMax !== -1 && state.hfilter.sizeMin >= state.hfilter.sizeMax; };
var getHfilterTranslate = function (state) { return state.hfilter.t; };
var getCurrentGroupIndex = function (state) { return state.hfilter.keywordGroupIndex; };
var getCurrentRowIndex = function (state) { return state.hfilter.keywordRowIndex; };
var getSuggestionGroups = function (state) { return state.hfilter.keywordSuggestionGroups.length ? state.hfilter.keywordSuggestionGroups : state.hfilter.keywordHistoryGroups; };
var isDistrictActive = function (state, districtId) { return state.hfilter.districts.find(function (it) { return it.id === districtId; }).selected; };
var getKeyword = function (state) { return state.hfilter.keyword; };
var getSfilterType = function (state) { return SfilterTypeGroup_1.ListingPurposeType.toSfilterType(state.hfilter.listingType); };
var getIsPriceFilterActive = function (state) { return state.hfilter.priceActive; };
var getIsSizeFilterActive = function (state) { return state.hfilter.sizeActive; };
var getSearchResultType = function (state) { return state.hfilter.searchResultType; };
var getSearchResultId = function (state) { return state.hfilter.searchResultId; };
var watchFullFilterToggle = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take([HfilterAction_1.default.SET_FILTER_OPEN])];
            case 1:
                payload = (_a.sent()).payload;
                if (!(payload === true)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setSortPanelActive(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.closeAll())];
            case 3:
                _a.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setFullKeywordPanelActive(false))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchHfilterBarToggle = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take([HfilterAction_1.default.ON_LISTING_TYPE_TOGGLE, HfilterAction_1.default.ON_DISTRICT_TOGGLE, HfilterAction_1.default.ON_PRICE_TOGGLE, HfilterAction_1.default.ON_SIZE_TOGGLE, HfilterAction_1.default.ON_BEDS_TOGGLE, HfilterAction_1.default.ON_PROPERTY_TYPE_TOGGLE, HfilterAction_1.default.ON_AMENITY_TOGGLE])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setSortPanelActive(false))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnClearDoSearch = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take([HfilterAction_1.default.ON_PRICE_CLEAR, HfilterAction_1.default.ON_SIZE_CLEAR, HfilterAction_1.default.ON_TYPE_CLEAR, HfilterAction_1.default.ON_AMENITY_CLEAR, HfilterAction_1.default.ON_BED_CLEAR])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchListingTypeSelect = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_LISTING_TYPE_SELECTED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onPriceClear())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchAreaToggle = function () {
    var payload, area, isExpanded;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_AREA_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                area = payload;
                return [4 /*yield*/, effects_1.select(getAreaIsExpanded, area)];
            case 2:
                isExpanded = _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setAreaExpanded(area, !isExpanded))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchDistrictClick = function () {
    var payload, districtId, isActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_DISTRICT_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                districtId = payload;
                return [4 /*yield*/, effects_1.select(isDistrictActive, districtId)];
            case 2:
                isActive = _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setDistrictActive(districtId, !isActive))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var onDistrictConfirmClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_DISTRICT_CONFIRM_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setFullDistrictActive(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var onPricePresetClick = function () {
    var payload, preset, hfilter;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_PRICE_PRESET_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                preset = payload;
                return [4 /*yield*/, effects_1.select(getCurrentHfilter)];
            case 2:
                hfilter = _a.sent();
                if (!(hfilter.priceMax === preset.to && hfilter.priceMin === preset.from)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onPriceClear())];
            case 3:
                _a.sent();
                return [3 /*break*/, 7];
            case 4: return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onPriceMinMaxChanged(preset.from, preset.to))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var onSizePresetClick = function () {
    var payload, preset, hfilter;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_SIZE_PRESET_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                preset = payload;
                return [4 /*yield*/, effects_1.select(getCurrentHfilter)];
            case 2:
                hfilter = _a.sent();
                if (!(hfilter.sizeMax === preset.to && hfilter.sizeMin === preset.from)) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onSizeClear())];
            case 3:
                _a.sent();
                return [3 /*break*/, 7];
            case 4: return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onSizeMinMaxChanged(preset.from, preset.to))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var onPriceContinueClick = function () {
    var isInvalid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_PRICE_CONTINUE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsPriceMinBiggerThanPriceMax)];
            case 2:
                isInvalid = _a.sent();
                if (isInvalid)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var onPriceCustomChanged = function () {
    var task, isFilterFullActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take([HfilterAction_1.default.ON_PRICE_MIN_CHANGED, HfilterAction_1.default.ON_PRICE_MAX_CHANGED])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsFilterFullActive)];
            case 2:
                isFilterFullActive = _a.sent();
                if (isFilterFullActive)
                    return [3 /*break*/, 0];
                if (!task) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.cancel(task)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, effects_1.fork(function () {
                    var isInvalid;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.delay(1000)];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, effects_1.select(getIsPriceMinBiggerThanPriceMax)];
                            case 2:
                                isInvalid = _a.sent();
                                if (isInvalid)
                                    return [2 /*return*/];
                                return [4 /*yield*/, effects_1.put(SearchQueryAction_1.default.search())];
                            case 3:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 5:
                task = _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var onSizeCustomChanged = function () {
    var task, isFilterFullActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take([HfilterAction_1.default.ON_SIZE_MIN_CHANGED, HfilterAction_1.default.ON_SIZE_MAX_CHANGED])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsFilterFullActive)];
            case 2:
                isFilterFullActive = _a.sent();
                if (isFilterFullActive)
                    return [3 /*break*/, 0];
                if (!task) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.cancel(task)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [4 /*yield*/, effects_1.fork(function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.delay(1000)];
                            case 1:
                                _a.sent();
                                return [4 /*yield*/, effects_1.put(SearchQueryAction_1.default.search())];
                            case 2:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 5:
                task = _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var onSizeContinueClick = function () {
    var isInvalid;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_SIZE_CONTINUE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsSizeMinBiggerThanSizeMax)];
            case 2:
                isInvalid = _a.sent();
                if (isInvalid)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var onBedPresetClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_BED_PRESET_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onTypeContinueClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_TYPE_CONTINUE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onAmenitiesContinueClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_AMENITY_CONTINUE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var initKeywordHistories = function () {
    var hfilterTranslate, histories, historyGroup;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getHfilterTranslate)];
            case 1:
                hfilterTranslate = _a.sent();
                return [4 /*yield*/, effects_1.call(SearchHistory_1.getSearchHistories)];
            case 2:
                histories = _a.sent();
                historyGroup = {
                    id: 0,
                    name: hfilterTranslate.histories,
                    suggestions: histories
                };
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setKeywordHistoryGroups([historyGroup]))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var onKeywordFocus = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_KEYWORD_FOCUS)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(initKeywordHistories)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setKeywordPanelActive(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var onFullKeywordFocus = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_FULL_KEYWORD_FOCUS)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setFullKeywordPanelActive(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onFullKeywordBackgroundClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_KEYWORD_BACKGROUND_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setFullKeywordPanelActive(false))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onFilterBackgroundClick = function () {
    var isPriceFilterActive, isSizeFilterActive;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_FILTER_BACKGROUND_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsPriceFilterActive)];
            case 2:
                isPriceFilterActive = _a.sent();
                return [4 /*yield*/, effects_1.select(getIsSizeFilterActive)];
            case 3:
                isSizeFilterActive = _a.sent();
                if (!isPriceFilterActive) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onPriceToggle())];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5:
                if (!isSizeFilterActive) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onSizeToggle())];
            case 6:
                _a.sent();
                return [3 /*break*/, 0];
            case 7: return [4 /*yield*/, effects_1.call(doSearch)];
            case 8:
                _a.sent();
                return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
var delaySuggestion = function () {
    var lang, rawKeyword, keywordInput, type, hfilterTranslate, keyword, isChinese, minAutocompleteLength, suggestions, suggestionGroups;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.delay(800)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setKeywordSuggestionGroups([]))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguage)];
            case 3:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.select(getKeyword)];
            case 4:
                rawKeyword = _a.sent();
                keywordInput = getPartBy_1.getPartBy(lang, rawKeyword.split(' | '));
                return [4 /*yield*/, effects_1.select(getSfilterType)];
            case 5:
                type = _a.sent();
                return [4 /*yield*/, effects_1.select(getHfilterTranslate)];
            case 6:
                hfilterTranslate = _a.sent();
                keyword = keywordInput.trim();
                return [4 /*yield*/, effects_1.call(WindowApi_1.checkIsChinese, keyword)];
            case 7:
                isChinese = _a.sent();
                minAutocompleteLength = isChinese ? 1 : 3;
                if (keyword.length < minAutocompleteLength)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setKeywordLoading(true))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.call(getKeywordSuggestions_1.getKeywordSuggestionsByType, keyword, type)];
            case 9:
                suggestions = _a.sent();
                return [4 /*yield*/, effects_1.call(groupRows_1.groupRows, suggestions, hfilterTranslate)];
            case 10:
                suggestionGroups = _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setKeywordLoading(false))];
            case 11:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setKeywordSuggestionGroups(suggestionGroups))];
            case 12:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchKeywordChanged = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeLatest(HfilterAction_1.default.ON_CHANGE_KEYWORD, delaySuggestion)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var onSearchKeywordMouseEnter = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_SEARCH_KEYWORD_MOUSE_ENTER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setSearchKeywordFocus(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onSuggestionMouseEnter = function () {
    var payload, groupIndex, rowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_SUGGESTION_MOUSE_ENTER)];
            case 1:
                payload = (_a.sent()).payload;
                groupIndex = payload.groupIndex, rowIndex = payload.rowIndex;
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setSuggestionGroupRowIndex(groupIndex, rowIndex))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onHistoryMouseEnter = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_HISTORY_MOUSE_ENTER)];
            case 1:
                payload = (_a.sent()).payload;
                return [3 /*break*/, 0];
            case 2: return [2 /*return*/];
        }
    });
};
var onSuggesgionItemSelected = function (suggestion) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setSearchFromSuggestion(suggestion.name, suggestion.type, suggestion.id))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch, true)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var onSearchKeywordClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_SEARCH_KEYWORD_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onEnterPressed())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onSuggestionClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_SUGGESTION_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onKeywordEnter())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onHistoryClick = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_HISTORY_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                return [3 /*break*/, 0];
            case 2: return [2 /*return*/];
        }
    });
};
var watchOnClickInputBox = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(SbarAction_1.default.ON_CLICK_INPUTBOX)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setFilterOpen(true))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(focusFullKeywordFields)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var blurKeywordFields = function () {
    var element, element2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(document !== undefined)) return [3 /*break*/, 3];
                element = document.getElementById('search-keyword-input');
                element2 = document.getElementById('search-keyword-input-full');
                return [4 /*yield*/, effects_1.call(WindowApi_1.setElementBlur, element)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setElementBlur, element2)];
            case 2:
                _a.sent();
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
};
var focusFullKeywordFields = function () {
    var element;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(document !== undefined)) return [3 /*break*/, 2];
                element = document.getElementById('search-keyword-input-full');
                return [4 /*yield*/, effects_1.call(WindowApi_1.setElementFocus, element)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
};
var onKeywordEnter = function () {
    var rawKeyword, groupIndex, rowIndex, suggestionGroups, suggestion, lang, isChinese, keyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_KEYWORD_ENTER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getKeyword)];
            case 2:
                rawKeyword = _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setKeyword(rawKeyword))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentGroupIndex)];
            case 4:
                groupIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentRowIndex)];
            case 5:
                rowIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getSuggestionGroups)];
            case 6:
                suggestionGroups = _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setFullKeywordPanelActive(false))];
            case 7:
                _a.sent();
                suggestion = (groupIndex > -1 && rowIndex > -1) ? suggestionGroups[groupIndex].suggestions[rowIndex] : {
                    id: 0,
                    name: rawKeyword,
                    type: GetSuggestionApiResponse_1.GetSuggestionResultType.Keyword,
                };
                return [4 /*yield*/, effects_1.call(blurKeywordFields)];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguage)];
            case 9:
                lang = _a.sent();
                isChinese = lang === LayoutState_1.Language.EN_US ? false : true;
                keyword = getPartBy_1.getPartBy(isChinese, suggestion.name.split(' | '));
                return [4 /*yield*/, effects_1.call(onSuggesgionItemSelected, __assign(__assign({}, suggestion), { name: keyword }))];
            case 10:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.closeAll())];
            case 11:
                _a.sent();
                return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
var onKeywordEscape = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_KEYWORD_ESCAPE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.closeAll())];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(blurKeywordFields)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchSaveKeywordHistory = function () {
    var payload, keyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.SET_KEYWORD)];
            case 1:
                payload = (_a.sent()).payload;
                keyword = payload;
                if (!keyword.trim() || keyword.length <= 1)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(SearchHistory_1.searchHistoryAdd, keyword)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onSortOptionClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_SORT_OPTION_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(doSearch)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnSaveClick = function () {
    var isGuest, heading, searchId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 17];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_SAVE_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuest = _a.sent();
                if (!isGuest) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setReturnState('ss'))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelDim(true))];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SignupAction_1.default.setPanelActive(true))];
            case 6:
                _a.sent();
                return [3 /*break*/, 16];
            case 7: return [4 /*yield*/, effects_1.select(RootSearchCallSaga_1.getSearchHeading)];
            case 8:
                heading = _a.sent();
                if (!heading)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.select(WindowApi_1.getSearchId)];
            case 9:
                searchId = _a.sent();
                if (!!searchId) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.onCustomNameChanged(heading))];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.onSetDim(true))];
            case 12:
                _a.sent();
                return [4 /*yield*/, effects_1.delay(100)];
            case 13:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.onSetActive(true))];
            case 14:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SaveSearchDialogAction_1.default.setSaveNewEnabled(true))];
            case 15:
                _a.sent();
                _a.label = 16;
            case 16: return [3 /*break*/, 0];
            case 17: return [2 /*return*/];
        }
    });
};
var watchCustomClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take([HfilterAction_1.default.ON_SIZE_CUSTOM_CLICK, HfilterAction_1.default.ON_PRICE_CUSTOM_CLICK])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setFilterOpen(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchFilterClearClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_CLEAR_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setKeyword(''))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onDistrictClear())];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onPriceClear())];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onSizeClear())];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onBedClear())];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onTypeClear())];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onAmenitiesClear())];
            case 8:
                _a.sent();
                return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
var watchClearBoundaryClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_CLEAR_BOUNDARY_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.resetMap())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
/* do search */
var watchFullPanelSetNoScroll = function () {
    var payload, open;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take([HfilterAction_1.default.SET_SORT_OPEN, HfilterAction_1.default.SET_FILTER_OPEN, HfilterAction_1.default.SET_MAP_ACTIVE])];
            case 1:
                payload = (_a.sent()).payload;
                open = payload;
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setNoscroll(open))];
            case 2:
                _a.sent();
                if (!!open) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setFullKeywordPanelActive(false))];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var watchApplyFilterClick = function () {
    var searchQuery, hfilter, action1, _a, _b, _c, search, close, newSearchQuery, _d, _e, payload;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                searchQuery = null;
                hfilter = null;
                _f.label = 1;
            case 1:
                if (!true) return [3 /*break*/, 17];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.SET_FILTER_OPEN)];
            case 2:
                action1 = _f.sent();
                if (action1.payload === false)
                    return [3 /*break*/, 1];
                _a = effects_1.call;
                _b = [stateToSearchQuery_1.stateToSearchQuery];
                return [4 /*yield*/, effects_1.select()];
            case 3: return [4 /*yield*/, _a.apply(void 0, _b.concat([_f.sent()]))];
            case 4:
                searchQuery = _f.sent();
                return [4 /*yield*/, effects_1.select(getCurrentHfilter)];
            case 5:
                hfilter = _f.sent();
                return [4 /*yield*/, effects_1.race({
                        search: effects_1.take(HfilterAction_1.default.ON_SEARCH_CLICK),
                        close: effects_1.take(HfilterAction_1.default.SET_FILTER_OPEN),
                    })];
            case 6:
                _c = _f.sent(), search = _c.search, close = _c.close;
                if (search)
                    return [3 /*break*/, 1];
                if (close.payload !== false)
                    return [3 /*break*/, 1];
                _d = effects_1.call;
                _e = [stateToSearchQuery_1.stateToSearchQuery];
                return [4 /*yield*/, effects_1.select()];
            case 7: return [4 /*yield*/, _d.apply(void 0, _e.concat([_f.sent()]))];
            case 8:
                newSearchQuery = _f.sent();
                if (!(JSON.stringify(searchQuery) !== JSON.stringify(newSearchQuery))) return [3 /*break*/, 16];
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setHasUnsaved(true))];
            case 9:
                _f.sent();
                return [4 /*yield*/, effects_1.take(ApplyFilterAction_1.default.ON_BUTTON_CLICKED)];
            case 10:
                payload = (_f.sent()).payload;
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setHasUnsaved(false))];
            case 11:
                _f.sent();
                if (!payload) return [3 /*break*/, 13];
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onSearchClick())];
            case 12:
                _f.sent();
                return [3 /*break*/, 16];
            case 13:
                if (!(hfilter != null)) return [3 /*break*/, 16];
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setHfilter(hfilter))];
            case 14:
                _f.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setFilterOpen(false))];
            case 15:
                _f.sent();
                _f.label = 16;
            case 16: return [3 /*break*/, 1];
            case 17: return [2 /*return*/];
        }
    });
};
var watchOnSearchClick = function () {
    var viewport;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 10];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_SEARCH_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsPriceMinBiggerThanPriceMax)];
            case 2:
                if (_a.sent())
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.put(SearchMapAction_1.default.addCacheData(null))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.select(RootSearchMapCallSaga_1.getViewport)];
            case 4:
                viewport = _a.sent();
                return [4 /*yield*/, effects_1.put(SearchQueryAction_1.default.search(viewport))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.closeAll())];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setFilterOpen(false))];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setSortPanelActive(false))];
            case 8:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setSortOpen(false))];
            case 9:
                _a.sent();
                return [3 /*break*/, 0];
            case 10: return [2 /*return*/];
        }
    });
};
var doSearch = function (force) {
    var isFilterFullActive;
    if (force === void 0) { force = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setSuggestionGroupRowIndex(-1, -1))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getIsFilterFullActive)];
            case 2:
                isFilterFullActive = _a.sent();
                if (isFilterFullActive && !force)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.onSearchClick())];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnEnterPressed = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_ENTER_PRESSED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.closeAll())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnKeywordUp = function () {
    var groupIndex, rowIndex, suggestionGroups, nextGroupIndex, nextRowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_KEYWORD_PREVIOUS)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentGroupIndex)];
            case 2:
                groupIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentRowIndex)];
            case 3:
                rowIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getSuggestionGroups)];
            case 4:
                suggestionGroups = _a.sent();
                nextGroupIndex = groupIndex > -1 ? (rowIndex <= 0 ? (groupIndex <= 0 ? suggestionGroups.length - 1 : groupIndex - 1) : groupIndex) : 0;
                nextRowIndex = rowIndex > -1 ? (rowIndex <= 0 ? suggestionGroups[nextGroupIndex].suggestions.length - 1 : rowIndex - 1) : 0;
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setSuggestionGroupRowIndex(nextGroupIndex, nextRowIndex))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchOnKeywordDown = function () {
    var groupIndex, rowIndex, suggestionGroups, nextGroupIndex, nextRowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(HfilterAction_1.default.ON_KEYWORD_NEXT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentGroupIndex)];
            case 2:
                groupIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentRowIndex)];
            case 3:
                rowIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getSuggestionGroups)];
            case 4:
                suggestionGroups = _a.sent();
                nextGroupIndex = groupIndex > -1 ? (rowIndex === suggestionGroups[groupIndex].suggestions.length - 1 ? (groupIndex === suggestionGroups.length - 1 ? 0 : groupIndex + 1) : groupIndex) : 0;
                nextRowIndex = rowIndex > -1 ? (rowIndex === suggestionGroups[groupIndex].suggestions.length - 1 ? 0 : rowIndex + 1) : 0;
                return [4 /*yield*/, effects_1.put(HfilterAction_1.default.setSuggestionGroupRowIndex(nextGroupIndex, nextRowIndex))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var hfilterSagas = {
    watchListingTypeSelect: watchListingTypeSelect,
    watchFullFilterToggle: watchFullFilterToggle,
    watchHfilterBarToggle: watchHfilterBarToggle,
    watchAreaToggle: watchAreaToggle,
    watchDistrictClick: watchDistrictClick,
    onDistrictConfirmClick: onDistrictConfirmClick,
    onPricePresetClick: onPricePresetClick,
    onPriceContinueClick: onPriceContinueClick,
    onPriceCustomChanged: onPriceCustomChanged,
    onSizeContinueClick: onSizeContinueClick,
    onSizePresetClick: onSizePresetClick,
    onSizeCustomChanged: onSizeCustomChanged,
    onBedPresetClick: onBedPresetClick,
    watchOnClearDoSearch: watchOnClearDoSearch,
    onTypeContinueClick: onTypeContinueClick,
    onAmenitiesContinueClick: onAmenitiesContinueClick,
    onKeywordFocus: onKeywordFocus,
    onFullKeywordFocus: onFullKeywordFocus,
    watchKeywordChanged: watchKeywordChanged,
    onSearchKeywordMouseEnter: onSearchKeywordMouseEnter,
    onSuggestionMouseEnter: onSuggestionMouseEnter,
    onHistoryMouseEnter: onHistoryMouseEnter,
    onSearchKeywordClick: onSearchKeywordClick,
    onSuggestionClick: onSuggestionClick,
    onHistoryClick: onHistoryClick,
    onKeywordEnter: onKeywordEnter,
    onKeywordEscape: onKeywordEscape,
    watchSaveKeywordHistory: watchSaveKeywordHistory,
    onFullKeywordBackgroundClick: onFullKeywordBackgroundClick,
    onFilterBackgroundClick: onFilterBackgroundClick,
    onSortOptionClick: onSortOptionClick,
    watchFullPanelSetNoScroll: watchFullPanelSetNoScroll,
    watchOnSaveClick: watchOnSaveClick,
    watchCustomClick: watchCustomClick,
    watchApplyFilterClick: watchApplyFilterClick,
    watchFilterClearClick: watchFilterClearClick,
    watchClearBoundaryClick: watchClearBoundaryClick,
    watchOnClickInputBox: watchOnClickInputBox,
    watchOnSearchClick: watchOnSearchClick,
    watchOnEnterPressed: watchOnEnterPressed,
    watchOnKeywordUp: watchOnKeywordUp,
    watchOnKeywordDown: watchOnKeywordDown,
};
exports.hfilterSagas = hfilterSagas;
